import '../../styles-new/pages/olympiad/schedule.scss';
import EmblaCarousel from 'embla-carousel';

import { countdownBar } from '../components/olympiad/countdown-bar';
import { addPrevNextBtnsClickHandlers } from '../components/embla-carousel-arrow-buttons';

const initCurrentEventsSlider = () => {
  const OPTIONS = { loop: true, align: 'start' };

  const emblaNode = document.querySelector('.olympiad-current-events-embla');
  const viewportNode = emblaNode.querySelector('.olympiad-current-events-embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.olympiad-current-events-embla__button--prev');
  const nextBtnNode = emblaNode.querySelector('.olympiad-current-events-embla__button--next');

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode
  );

  emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
}

const toggleItemsView = () => {
  const btnBlock = document.querySelector('.olympiad-disciplines__tabs_item_block');
  const btnList = document.querySelector('.olympiad-disciplines__tabs_item_list');
  const blocksSection = document.querySelector('.olympiad-disciplines__blocks');
  const tableSection = document.querySelector('.olympiad-disciplines__list');

  btnBlock.addEventListener('click', () => {
    btnBlock.classList.add('tabs__item_active');
    btnList.classList.remove('tabs__item_active');
    tableSection.classList.add('hidden');
    blocksSection.classList.remove('hidden');
  });

  btnList.addEventListener('click', () => {
    btnBlock.classList.remove('tabs__item_active');
    btnList.classList.add('tabs__item_active');
    tableSection.classList.remove('hidden');
    blocksSection.classList.add('hidden');
  });
};

const disciplinesSorting = () => {
  const sortingBtn = document.querySelector('.olympiad-disciplines-sorting__btn');
  const sortingDropdown = document.querySelector('.olympiad-disciplines-sorting__dropdown');
  const sortingText = document.querySelector('.olympiad-disciplines-sorting__text');
  const sortingOptions = document.querySelectorAll('.olympiad-disciplines-sorting__option');

  if (!sortingBtn || !sortingDropdown) return;

  // Toggle dropdown
  sortingBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    sortingDropdown.classList.toggle('olympiad-disciplines-sorting__dropdown--active');
    sortingBtn.classList.toggle('olympiad-disciplines-sorting__btn--active');
  });

  // Handle option selection
  sortingOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();
      const sortValue = option.getAttribute('data-sort');
      const optionText = option.textContent;
      
      // Update button text
      sortingText.textContent = optionText;
      
      // Remove active class from all options
      sortingOptions.forEach(opt => opt.classList.remove('olympiad-disciplines-sorting__option--active'));
      
      // Add active class to selected option
      option.classList.add('olympiad-disciplines-sorting__option--active');
      
      // Close dropdown
      sortingDropdown.classList.remove('olympiad-disciplines-sorting__dropdown--active');
      sortingBtn.classList.remove('olympiad-disciplines-sorting__btn--active');
      
      // Here you can add sorting logic
      console.log('Sort by:', sortValue);
      // sortTable(sortValue);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.olympiad-disciplines-sorting')) {
      sortingDropdown.classList.remove('olympiad-disciplines-sorting__dropdown--active');
      sortingBtn.classList.remove('olympiad-disciplines-sorting__btn--active');
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  countdownBar();
  initCurrentEventsSlider();
  toggleItemsView();
  disciplinesSorting();
});